var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 10C19.3335 14.9706 15.3041 19 10.3335 19C5.36293 19 1.3335 14.9706 1.3335 10C1.3335 5.02944 5.36293 1 10.3335 1C11.7455 1 13.0817 1.32519 14.271 1.90476M17.646 4.375L9.771 12.25L7.521 10",
    stroke: "#8B5CF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignActive);
export default __webpack_public_path__ + "static/media/campaign-active.097e142bca152e159fd70f51d2409be9.svg";
export { ForwardRef as ReactComponent };